import { createContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { CssBaseline } from "@mui/material";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import SideBar from "./side-bar";
import TwilioChatNowWindow from "components/twilio-chat/chat-now-window";
import { fetchPatientFormAttributes } from "actions/user";
import { AppBarHeader } from "components/ui";
import SkipNavigation from "components/shared/skip-navigation";
import "./layout.scss";

export const AppLayoutContext = createContext();

const AppLayout = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileDrawerOpen(!mobileDrawerOpen);
  };

  useEffect(() => {
    dispatch(fetchPatientFormAttributes());
  }, [dispatch]);

  return (
    <div className="app">
      <CssBaseline />
      <SkipNavigation />
      <AppBarHeader
        onMenuClick={handleDrawerToggle}
        mobileMenuOpen={mobileDrawerOpen}
      />
      <SideBar
        mobileOpen={mobileDrawerOpen}
        onDrawerToggle={handleDrawerToggle}
      />
      <AppLayoutContext.Provider>
        <main className="main">
          <div className={location.pathname === "/" || location.pathname === "/dashboard" ? "welcome-toolbar" : "toolbar"} />
          <div className="main-content" id="main-content" tabIndex="-1">
            {children}
          </div>
        </main>
        <TwilioChatNowWindow />
      </AppLayoutContext.Provider>
    </div>
  );
};

export default AppLayout;

AppLayout.propTypes = { children: PropTypes.node };
